import { ChartType, ChartEvent } from '../../shared/chartist.component';
import { IOrganization, IAccount } from '../../../interfaces/graph-types';
import { Component, OnInit } from '@angular/core';
import { OrganizationService } from '../../../services/organization.service';
import * as Chartist from 'chartist';
import 'chartist-plugin-tooltips';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalCreateAccountComponent } from '../../modals/create-account/modal-create-account.component';
import { PaginationTemplate } from '../../../interfaces/pagination';
import { BehaviorSubject, Subscription, Subject } from 'rxjs';
import { Apollo, gql } from 'apollo-angular-boost';
import { WatchOrganizationService } from '../../../services/watch-organization.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export interface Chart {
  type: string;
  data: Chartist.IChartistData;
  options?: any;
  responsiveOptions?: any;
  events?: ChartEvent;
}

@Component({
  selector: '[organization-accounts]',
  template: require('./organization-accounts.component.pug'),
  styles: [require('./organization-accounts.component.css').toString()],
})
export class OrganizationAccountsComponent implements OnInit {
  img_empty = require('./empty.png').default;
  //public organization: IOrganization;
  public type: ChartType;
  public events: ChartEvent;
  public options: any;
  bsModalRef: BsModalRef;
  orgsub: any = null;
  accsub: any = null;

  searchChanged: Subject<any> = new Subject<any>();

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private apollo: Apollo,
    private watchService: WatchOrganizationService,
  ) {
    this.countTotal = new BehaviorSubject<number>(0);
    this.options = {
      axisY: { onlyInteger: true },
      plugins: [Chartist.plugins.tooltip()],
    };
  }

  itemPerPage = 30;
  maxSize = 10;
  currentPage: number = 1;
  totalCount = null;

  // -------------------------------------------------------------------
  isLoading() {
    return this.accountPagination.isLoading();
  }

  // -------------------------------------------------------------------
  buildQuery() {
    return this.apollo.watchQuery<{ account: IAccount }>({
      query: gql`
        query accountPagination(
          $first: Int
          $last: Int
          $after: String
          $before: String
          $skip: Int
          $organizationId: ID!
          $searchFilter: String
          $logonId: ID
        ) {
          organization(orgId: $organizationId) {
            id
            accountList(
              first: $first
              last: $last
              after: $after
              before: $before
              skip: $skip
              searchFilter: $searchFilter
              logonId: $logonId
            ) {
              totalCount
              pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
              }
              edges {
                node {
                  id
                  name
                  plan
                }
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: false,
    });
  }

  searchFilter = { include_tags: [], in_group: null };

  // -------------------------------------------------------------------
  setPage(newPage: number) {
    if (this.currentPage == newPage) {
      return;
    }
    this.currentPage = newPage;
    this.accountPagination.setOffset((newPage - 1) * this.itemPerPage);
  }

  filter: string = '';

  archived = false;
  mine = false;

  accountPagination: PaginationTemplate<IAccount>;
  accountId: string;

  countTotal: BehaviorSubject<number>;

  orgId: string = null;

  // -------------------------------------------------------------------
  ngOnInit() {
    const query = this.buildQuery();

    this.orgId = this.watchService.organizationId().getValue();

    this.accountPagination = new PaginationTemplate<IAccount>(
      this.apollo,
      null,
      query,
      'organization',
      'accountList',
      null,
      null,
      this.searchFilter,
      () => {
        if (this.totalCount == null) {
          this.totalCount = this.accountPagination.totalCount; // to prevent that an empty search displays that the org has no account at all
        }
        this.countTotal.next(this.accountPagination.totalCount);
      },
      this.orgId,
    );

    this.type = 'Line';
    this.events = { draw: this.chartDrawEvent };
    // this.orgsub = this.org_service.organization().subscribe(org => {
    //   if (org) {
    //     console.log('Load stats for org: ' + org.id);
    //     this.accsub = this.org_service.accounts(org.id).subscribe(response => {
    //       this.organization = response;
    //     });
    //   }
    // });

    this.searchChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(model => this.startSearch(model));
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    // if (this.orgsub) {
    //   //console.log('UNSUBSCRIBE');
    //   this.orgsub.unsubscribe();
    // }
    if (this.accsub) {
      //console.log('UNSUBSCRIBE');
      this.accsub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  trackByFn(index, item) {
    // https://medium.freecodecamp.org/best-practices-for-a-clean-and-performant-angular-application-288e7b39eb6f
    return item.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  backgroundImg() {
    if (
      this.accountPagination.isLoading() ||
      this.accountPagination.totalCount == 0
    ) {
      return 'url(' + this.img_empty + ')';
    }
  }

  // -------------------------------------------------------------------
  valueChanged(newvalue) {
    this.searchChanged.next(newvalue);
  }

  // -------------------------------------------------------------------
  startSearch(newvalue) {
    this.filter = newvalue;
    this.accountPagination.searchFilter.text = newvalue;
    this.accountPagination.setOffset(0, () => {});
  }

  // -------------------------------------------------------------------
  chartDrawEvent(context: any): void {
    //console.warn('Event');
    //console.warn(context);
    if (context.seriesIndex == 0) {
      // previous period
      context.element._node.style.stroke = '#dcdcdc';
    }
    if (context.seriesIndex == 1) {
      // current period
      context.element._node.style.stroke = '#1694ff';
    }
  }

  // -------------------------------------------------------------------
  OpenCreateAccountModal() {
    //this.account_service.account().subscribe(response => {
    const options: ModalOptions = new ModalOptions();
    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      org_id: 0, //response.organization.id,
    };
    this.bsModalRef = this.modalService.show(
      ModalCreateAccountComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
    //});
  }
}
